import { render, staticRenderFns } from "./ResourceItemList.vue?vue&type=template&id=86daf8c4&scoped=true&"
import script from "./ResourceItemList.vue?vue&type=script&lang=ts&"
export * from "./ResourceItemList.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceItemList.vue?vue&type=style&index=0&id=86daf8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86daf8c4",
  null
  
)

export default component.exports